import React from 'react';
import Flipbook from './Flipbook';

const ClubAndSociety = () =>{
    return(
        <Flipbook pdfFile="/assets/pdf/Clubs_and_Society_Manual_and_Procedures.pdf" />
    )
}

export default ClubAndSociety